import { Modal, ModalBody } from 'reactstrap';
import styled from 'styled-components';
import { getTranslationKey } from 'helpers/texting';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { selectActiveSelectionState } from 'store/selectors/activeSelection';
import { getDownloadUrl } from 'helpers/downloadUrl';
import {
  toggleSelectionDownloadResolutionModal,
  toggleInfoModal,
  toggleDownloadPinModal
} from 'store/slices/modals';
import { incrementImagesDownloadCount } from 'store/slices/app';
import { ModalHeader } from 'components/Modal/ModalHeader';
import { LinkBtn } from 'components/IconButton/LinkButton';

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  a {
    text-decoration: none !important;
  }
`;

type Quality = 'low' | 'high';

export const SelectionDownloadResolutionModal = () => {
  const dispatch = useAppDispatch();
  const { selectionDownloadResolutionModal } = useAppSelector((state) => state.modals);
  const { all, likes } = useAppSelector(selectActiveSelectionState);
  const { images } = useAppSelector((state) => state.images);
  const collection = useAppSelector((state) => state.collection);
  const environment = useAppSelector((state) => state.environment);

  const currentSelection = all.find((selection) => selection.current);

  const selectionImages = images.filter((image) => likes.includes(image._id));
  const isHighQualityAvailable = selectionImages.every((image) => !image._watermark);

  const toggleModal = () => dispatch(toggleSelectionDownloadResolutionModal());

  const handleDownload = (quality: Quality) => {
    if (!currentSelection?._id) return;

    const { url, infoModalText, infoModalText2 } = getDownloadUrl(
      { selection_id: currentSelection._id },
      { collection, environment, quality }
    );

    toggleModal();

    if (infoModalText || infoModalText2) {
      dispatch(toggleInfoModal({ text1: infoModalText, text2: infoModalText2 }));
    }

    if (url) {
      if (collection.downloadPinActive && collection.downloadPin) {
        dispatch(toggleDownloadPinModal({ action: 'startDownload', url }));
      } else {
        // @ts-ignore
        window.downloadFile(url);
        dispatch(incrementImagesDownloadCount());
      }
    }
  };

  return (
    <Modal
      centered
      isOpen={selectionDownloadResolutionModal.isOpen}
      toggle={toggleModal}
      wrapClassName="modal-primary modal-site download-selection-modal"
      size="medium"
      zIndex={999999}
    >
      <ModalHeader toggle={toggleModal}>
        {getTranslationKey('selections.downloadSelection')}
      </ModalHeader>
      <ModalBody>
        <ButtonsWrapper>
          <button
            type="button"
            data-cy="download-selection-low"
            className="sb-btn w-100-p m-b-10"
            onClick={() => handleDownload('low')}
          >
            {getTranslationKey('downloadImageLow')}
          </button>
          {isHighQualityAvailable && (
            <button
              type="button"
              data-cy="download-selection-high"
              className="sb-btn w-100-p"
              onClick={() => handleDownload('high')}
            >
              {getTranslationKey('downloadImageHigh')}
            </button>
          )}
        </ButtonsWrapper>
        <LinkBtn
          className="text-center mt-2 cursor-pointer"
          style={{ textDecoration: 'underline' }}
          onClick={toggleModal}
          aria-hidden="true"
        >
          {getTranslationKey('closeWindow')}
        </LinkBtn>
      </ModalBody>
    </Modal>
  );
};
